import { Copy } from 'lucide-react';
import { toast } from 'sonner';

import { Button } from '~shared/shadcn/ui/button';
import { copyToClipboard } from '~shared/utils/clipboard';

interface ImportSessionIdBarProps {
  jobId?: string | null;
  wizardSessionId: string;
}

export function ImportSessionIdBar({
  jobId,
  wizardSessionId,
}: ImportSessionIdBarProps) {
  const sessionId = jobId ?? wizardSessionId;

  const handleCopy = async () => {
    const copied = await copyToClipboard(sessionId);
    if (copied) {
      toast.success('Session ID copied');
    } else {
      toast.error('Could not copy session ID');
    }
  };

  return (
    <div className='flex items-center gap-1.5 text-xs text-muted-foreground'>
      <span className='shrink-0'>Session</span>
      <code className='truncate rounded bg-muted px-1.5 py-0.5 font-mono text-foreground'>
        {sessionId}
      </code>
      <Button
        type='button'
        variant='ghost'
        size='icon'
        className='size-6 shrink-0'
        onClick={() => void handleCopy()}
        aria-label='Copy import session ID'
        title='Copy session ID'
      >
        <Copy className='size-3.5' />
      </Button>
    </div>
  );
}
